import React, { Fragment, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'

import PdfHelper from '../../../Helpers/Pdf'
import SesionesHelper from '../../../Helpers/Sesiones'

import icon1 from '../../../Images/Icon/63.png'
import './PDF.css'

// NOTA: los tipos de sesiones son:
// 0: horarios => 65729a2274e61c9f1158ff8a
// 1: horarios examenes => 65729a1974e61c9f1158ff87
// 2: calificaciones => 65729a1d74e61c9f1158ff88
// 3: derecho a examen => 65729a2074e61c9f1158ff89

const PDF = () => {
  const { tipo } = useParams()
  const vista = [
    'HORARIOS',
    'HORARIO DE EXÁMENES',
    'CALIFICACIONES',
    'DERECHO A EXAMEN'
  ]
  const [pdfs, setPdfs] = useState([])
  const [sesiones, setSesiones] = useState('')
  const [password, setPaswwor] = useState('')

  useEffect(() => {
    obtenerSesion()
  }, [])

  const obtenerSesion = async () => {
    let res = await SesionesHelper.obtenerUnaSesion(tipo)
    if (res.success) {
      setPaswwor(res.data[0].password)
      setSesiones(res.data[0])
      obtenerPDF()
    } else {
      Swal.fire(
        'Error!',
        'No se pudo obtener la información, codigo: ' + res.code,
        'error'
      )
    }
  }

  const obtenerPDF = async () => {
    let res = await PdfHelper.obtenerPdfCampo(tipo)
    if (res.success) {
      setPdfs(res.data)
    } else {
      Swal.fire(
        'Error!',
        'No se pudo obtener la información, codigo: ' + res.code,
        'error'
      )
    }
  }

  const eliminarPDF = async (id) => {
    const res = await PdfHelper.eliminarPdf(id)
    if (res?.success) obtenerPDF()
  }

  const leerDato = (e) => {
    setPaswwor(e.target.value)
  }

  const actualizarSesion = () => {
    let data = { password }
    SesionesHelper.editarSesion(data, sesiones._id)
  }

  return (
    <Fragment>
      <div>
        <p
          className="titulo_solicitud"
          style={{ textAlign: 'center', marginBottom: '10px' }}
        >
          {vista[tipo]}
        </p>
        <div className="cont_horario">
          <div className="fondo_horarios">
            <div className="texto_pass">
              <p style={{ fontWeight: 'bold' }}>Contraseña:</p>
              <div className="input-field">
                <input
                  style={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '20px',
                    color: '#707070'
                  }}
                  defaultValue={password}
                  onChange={leerDato}
                  id="password"
                  name="password"
                  type="text"
                  className="validate"
                />
              </div>
              <button onClick={actualizarSesion} className="btn_horario">
                Cambiar
              </button>
            </div>
          </div>
          <div>
            {pdfs.map((pdf) => (
              <div className="box_horario">
                <p>{pdf.titulo}</p>
                <button
                  onClick={() => {
                    eliminarPDF(pdf._id)
                  }}
                  style={{ background: 'none', border: 'none' }}
                >
                  <img src={icon1} alt="eliminar pdf" />
                </button>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Link to={`/agregar-pdf/${tipo}`} className="btn_h1">
              Agregar archivo
            </Link>
            <Link to="/estudiantes" className="btn_h2">
              Regresar
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default PDF
